import React from 'react'
import { Container } from 'semantic-ui-react'

import './styles.css'

interface PageProps {
  children: React.ReactNode
}

export default function Page({ children }: PageProps) {
  return <Container className="page">{children}</Container>
}



// WEBPACK FOOTER //
// ./src/shared/components/Page/index.tsx